var map = {
	"./01high.svg": 36950,
	"./bug.svg": 39303,
	"./flame.svg": 68888,
	"./low.svg": 43187,
	"./medium.svg": 67114,
	"./rocket.svg": 71031,
	"./signal.svg": 3099,
	"./zap.svg": 13060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64979;